export class Qna {
  question: string;
  answer: string;
}
